import { primarySemiBoldFont, theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { responsiveText, spacing } = theme;

export const drawerLink = css`
  display: flex;
  ${responsiveText.BODY.SM};
  ${primarySemiBoldFont};
  color: var(--brand-purple-base);
  text-decoration: none;
`;

export const skeletonWrapper = css`
  display: grid;
  row-gap: ${spacing.sm}px;
  grid-template-columns: auto;
  margin: 0;
  padding: 0;
`;
